import { RouteData } from '@sitecore-jss/sitecore-jss-nextjs';

// TODO: remove this nasty function when the BE is updated to return camelCase keys
function toCamelCase(str: string) {
  return str
    .replace(/([-_ ]([a-z]|[0-9]))/gi, (match: string) => match.toUpperCase().replace(/[-_ ]/g, ''))
    .replace(/^([A-Z])/, (match: string) => match.toLowerCase());
}

const whitelist: (string | RegExp)[] = [/^col-.*/, 'taxonomy_ids_sm', 'erfeed_s'];

const isWhitelisted = (key: string): boolean => {
  return whitelist.some((pattern) => {
    if (typeof pattern === 'string') {
      return key === pattern;
    }
    return pattern.test(key);
  });
};

// TODO: remove this nasty function when the BE is updated to return camelCase keys
export function keysToCamelCase(obj: RouteData): RouteData {
  if (Array.isArray(obj)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return obj.map(keysToCamelCase);
  } else if (obj !== null && typeof obj === 'object') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return Object.entries(obj).reduce<Record<string, unknown>>((acc, [key, value]) => {
      if (key === 'attributes' || key === 'marketInsuranceFeeds' || key === 'insuranceFeed') {
        acc[key] = value; // Skip processing keys under "attributes"
        return acc;
      }
      const camelCasedKey = isWhitelisted(key) ? key : toCamelCase(key);
      acc[camelCasedKey] = keysToCamelCase(value);
      return acc;
    }, {});
  }
  return obj;
}
